export const resultTypes = [
  "全部处置",
  "警告并整改",
  "限制开播",
  "内容下架",
  "退还差额",
  "账号封禁",
];

export const resultMonths = ["全部月份", "2026-08", "2026-07", "2026-06"];

export const results = [
  {
    id: "res-2026-0829-01",
    eventId: "ev-2026-0824-01",
    title: "《深夜游戏夜话》连续画面中断事件",
    platform: "星野直播",
    category: "画面中断",
    resultType: "警告并整改",
    handledAt: "2026-08-29",
    cycle: "5 个工作日",
    summary:
      "认定推流服务切换配置异常，平台方未在中断期间有效告知观众。责令整改并警告，中断时段的付费内容予以顺延补足。",
  },
  {
    id: "res-2026-0826-02",
    eventId: "ev-2026-0819-02",
    title: "主播“阿洛不熬夜”引导私下交易事件",
    platform: "星河直播",
    category: "主播违规",
    resultType: "限制开播",
    handledAt: "2026-08-26",
    cycle: "5 个工作日",
    summary:
      "认定存在多次引导脱离平台交易行为，限制直播权限 7 天、下架相关回放并扣除违规积分，协助未履约订单退款。",
  },
  {
    id: "res-2026-0820-03",
    eventId: "",
    title: "直播间使用未授权背景音乐事件",
    platform: "晨光直播",
    category: "版权争议",
    resultType: "内容下架",
    handledAt: "2026-08-20",
    cycle: "4 个工作日",
    summary:
      "核查确认直播间长期使用未授权背景音乐，未标注曲目信息。下架涉及回放，要求补充授权台账。",
  },
  {
    id: "res-2026-0815-04",
    eventId: "ev-2026-0806-04",
    title: "“潮玩拆盒专线”抽奖规则不一致事件",
    platform: "晨光直播",
    category: "消费纠纷",
    resultType: "退还差额",
    handledAt: "2026-08-15",
    cycle: "6 个工作日",
    summary:
      "认定口播规则与公示规则不一致，要求补足抽奖次数并退还差额，整改期内暂停同类抽奖活动。",
  },
  {
    id: "res-2026-0809-05",
    eventId: "",
    title: "主播直播中使用不当言语事件",
    platform: "声浪直播",
    category: "主播违规",
    resultType: "账号封禁",
    handledAt: "2026-08-09",
    cycle: "3 个工作日",
    summary:
      "经回放比对确认多次出现不当言语且被投诉后未整改，账号予以封禁处理，相关回放全部下架。",
  },
  {
    id: "res-2026-0803-06",
    eventId: "",
    title: "“城市夜跑”直播间画面长期卡顿事件",
    platform: "巅峰赛事",
    category: "画面中断",
    resultType: "警告并整改",
    handledAt: "2026-08-03",
    cycle: "4 个工作日",
    summary:
      "确认推流码率配置不当导致长时间卡顿，平台责令整改并优化码率自适应策略，向观众公示说明。",
  },
  {
    id: "res-2026-0728-07",
    eventId: "ev-2026-0721-06",
    title: "“夜半翻唱电台”未署名翻唱事件",
    platform: "声浪直播",
    category: "版权争议",
    resultType: "内容下架",
    handledAt: "2026-07-28",
    cycle: "5 个工作日",
    summary:
      "认定未获授权曲目用于商业性翻唱且未署名，下架相关回放并要求完整标注原唱与词曲作者。",
  },
  {
    id: "res-2026-0716-08",
    eventId: "",
    title: "商家直播虚假承诺赠品事件",
    platform: "晨光直播",
    category: "消费纠纷",
    resultType: "退还差额",
    handledAt: "2026-07-16",
    cycle: "7 个工作日",
    summary:
      "核查确认赠品承诺未兑现，要求商家按承诺补发或按差价退还，并对营销话术进行合规整改。",
  },
  {
    id: "res-2026-0705-09",
    eventId: "",
    title: "直播间展示违规素材事件",
    platform: "星河直播",
    category: "内容违规",
    resultType: "内容下架",
    handledAt: "2026-07-05",
    cycle: "4 个工作日",
    summary:
      "确认直播间在背景素材中使用违规内容，已下架相关片段并要求直播间建立素材审核流程。",
  },
];

export const resultStats = [
  { label: "本月公示结果", value: "128", unit: "条" },
  { label: "整改完成率", value: "93.6", unit: "%" },
  { label: "申诉复核通过", value: "21", unit: "起" },
  { label: "平均处置周期", value: "4.8", unit: "天" },
];